import React, { useState } from 'react'

import { displayPopUp, closePopup, setGlobalState, getGlobalState, useGlobalState } from '../js/Main'

import * as FaIcons from 'react-icons/fa'
import { Link } from 'react-router-dom';

import { toggleMenu } from './Home';

import logo from '../images/crodudes_logo_1.png'

/* ------------------------- Created By Alhaji (C.CODES)
                             IG: c.codes_ig
                               Twitter: CCODES_web----------------------------------------- */




const Minted = () => {
    const nfts = useGlobalState("nfts")[0];
    var [pop, setpop] =  useState(null);
    const popUp = (id) => {
        pop = nfts.filter((nft) => {
            return id === nft.edition;
          });
          setpop(pop);
        document.querySelector(".minted-popup").style.transform = "scaleY(1)";
    }
    
    const popOut = () => {
        document.querySelector(".minted-popup").style.transform = "scaleY(0)";
    }
    if(nfts.length > 0 ){
        if(nfts[0].edition === 1){
            nfts.reverse();
        }
    }
    return (
        <>
        <header className="row">
            <div className="row logo">
                <div className="logo-box">
                <img src={ logo } alt="" />
                </div>
                <div>
                    CroCodudes
                </div>
            </div>
            <div className="toggle" onClick={ toggleMenu }>
                
            </div>
            <div className="sidebar row">
                <ul className="row">
                    <li onClick={toggleMenu} style={{color: '86A656'}}><Link to="/">Home</Link></li>
                    <li onClick={toggleMenu}><Link to="/minted">Minted</Link></li>
                    <li onClick={toggleMenu}><Link to="/dashboard">Dashboard</Link></li>
                    <li onClick={toggleMenu}><Link to="/about">About us</Link></li>
                    <li><FaIcons.FaWallet /></li>
                </ul>
            </div>
        </header>


        <div className=' row minted-popup'>
                <div className='column c-w-wrapper'>
                <div style={{color: 'red', textAlign: 'right', fontSize: '30px', cursor: 'pointer'}} onClick={ popOut }>
                    <FaIcons.FaTimes />
                </div>
                <div className='column nft-data'>
                    { pop ? pop.map((data) => (
                        <div className='row nft-main-info'>
                            <div className='nft-img'>
                                <img src={data.image} alt="" />
                            </div>
                            <div className='column nft-right'>
                                <div className='column nft-texts'>
                                    <h2>{data.name}</h2>
                                    <p>{data.description}</p>
                                    <div>Edition: {data.edition}</div>
                                    {/* <div>Reflection: { data.reflection < 1 ? parseFloat(data.reflection).toFixed(5) : parseInt(data.reflection).toLocaleString() } CRO</div> */}
                                </div>
                                <div className='nft-data-foot'>
                                    <h3>Attributes</h3>
                                    <div className='nft-attributes row'>
                                        {data.attributes.map((attr) => (
                                            <div key={attr.value}>
                                                {attr.trait_type} <span>:</span> {attr.value}
                                            </div>
                                        ))}
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    )) : () => {} }
                </div>
                </div>
            </div>


        
        <main>
        <section className="column section-2 minted-main-sec">
            <h1>Minted Crocs</h1>
            {nfts.length == 0 ? 
                <div className='spinner'>
                    <div></div>
                </div> 
                : () => {}
            }
            <div className="row boxes">
                {nfts.map((nft) => (
                    <div className="column box" key={ nft.edition } onClick={() => popUp(nft.edition)}>
                        <div>{ nft.name }</div>
                        <div className="box-img">
                            <img src={ nft.image } alt="" />
                        </div>
                        <div className="row">
                            Minted By: { nft.owner.slice(0,6) }......
                        </div>
                    </div>
                ))}
                
            </div>
        </section>
        </main>
        <footer className='row dash-footer'>
            <div className='main-color-text'>
                Copyright &copy;2022.CroCoDudes. All Rights Reserved
            </div>
            <div className='row'>
                <div>Terms & Conditions</div>
                <div>Privacy Policy</div>
            </div>
        </footer>
    </>
    )
}

export default Minted


/* ------------------------- Created By Alhaji (C.CODES)
                             IG: c.codes_ig
                               Twitter: CCODES_web----------------------------------------- */
